<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputDate" });
import Input from "../input/Input.svelte";
import { dateLong, dateRange } from "../../common/format.js";
export let value;
export let name;
export let label = void 0;
export let hint = void 0;
export let minimum = void 0;
export let maximum = void 0;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = true;
if (typeof minimum === "string" || typeof maximum === "string") {
    console.warn("s8", "Beware, Safari on IOS does not support min/max on time inputs");
}
const getHint = (hint2, minimum2, maximum2) => {
    if (hint2 !== void 0) {
        return hint2;
    }
    if (minimum2 !== void 0 && maximum2 !== void 0) {
        return dateRange(new Date(minimum2), new Date(maximum2));
    }
    if (minimum2 !== void 0) {
        return `after ${dateLong(new Date(minimum2))}`;
    }
    if (maximum2 !== void 0) {
        return `before ${dateLong(new Date(maximum2))}`;
    }
    return void 0;
};
$: defaultHint = getHint(hint, minimum, maximum);
</script>

<Input
    bind:value
    type = 'date'
    hint = { defaultHint }
    { name }
    { label }
    { minimum }
    { maximum }
    { isDisabled }
    { isReadonly }
    { isRequired }
    { ...$$restProps }
/>